<script setup lang="ts">
const solutions = [
  'Melayani pengiriman paket melalui jalur darat, laut, dan udara.',
  'Layanan penjemputan paket, tanpa repot antar paket berat ke agen.',
  'Bisa menghemat pengeluaran di biaya ongkos kirim.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-4 lg:py-16">
    <UiSectionWrapper
      image-class="lg:order-first"
      title="Kirim Paket Besar Jadi Lebih Hemat"
      description="Layanan pengiriman kargo menjadi solusi untuk kirim paket berukuran besar dengan mudah dan efisien."
      hero-image="/images/batch-2/cargo-add-1.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="flex gap-2"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <p class="text-sm lg:text-lg flex-1">
              {{ solution }}
            </p>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
  </div>
</template>
